import API from "@/config/api.js";

export const TaxService = {
  getTaxes(search = "", page = 1) {
    return API.get(`/api/tax/list?search=${search}&page=${page}`);
  },
  getTaxDetails(uuid) {
    return API.get(`/api/tax/details/${uuid}`);
  },
  createTax(data) {
    return API.post("/api/tax/create", data);
  },
  updateTax(uuid, data) {
    return API.post(`/api/tax/update/${uuid}`, data);
  },
  deleteTax(uuid) {
    return API.delete(`/api/tax/delete/${uuid}`);
  },
};
